import { default as Modal } from "./AbstractModal";
import { delegateEvent } from "../utils/events";

const LABEL_ELLIPSIS_LENGTH = 75;

export default class extends Modal {
    /**
     * The CSS class name to apply to `<html>` to mark the modal as open.
     *
     * @var {string}
     */
    activeClass = "has-external-open";

    constructor(m) {
        super(m);

        this.onTriggerClickBind = this.onTriggerClick.bind(this);

        // UI
        this.inner = this.$("inner")[0];
        this.$url = this.$("url")[0];
        this.$label = this.$("label")[0];
    }

    onInit() {
        this.unbindDelegateEventFn = delegateEvent(
            document,
            "click",
            'a[target="_blank"]',
            this.onTriggerClickBind
        );
    }

    onDestroy() {
        this.unbindDelegateEventFn?.();
    }

    ///////////////
    // Callbacks
    ///////////////
    onTriggerClick(e) {
        if (e.target === this.$url) {
            window.open(this.$url.href, '_blank');

            requestAnimationFrame(() => {
                this.close();
            });
        } else {
            e.preventDefault();
            const label = e.target.href
            this.$label.innerHTML = label.length > LABEL_ELLIPSIS_LENGTH ? label.substring(0, LABEL_ELLIPSIS_LENGTH) + '...' : label;
            this.$url.href = e.target.href;
    
            requestAnimationFrame(() => {
                this.open();
            });
        }
        
    }
}
